import { useVideoPlayerStore } from '@store/videoPlayerStore';
import { ReactElement } from 'react';
import { IPlayButton } from '.';
import { ToastType, useTosterStore } from '@store/toster';
import { FAILED_TO_PLAY_VIDEO, NO_JHAROKHA_PRODUCT_VIDEO_FOUND } from '@config/constant';
import { useFetchProductQuery } from '@services/hooks/jharokha/useGetJharokhaProduct';
import { useSiderToggleMenu } from '@store/useSiderToggleMenu';
import { useMutateJharokhaToken } from '@services/hooks/jharokha/useGetJharokhaTokenMutation';

export const PlayButton = (props: IPlayButton): ReactElement => {
	const { product_code } = props;
	const { setVideoPlayerState } = useVideoPlayerStore();
	const { setToaster } = useTosterStore();
	const { mutate } = useFetchProductQuery();
	const { setFullPageLoader } = useSiderToggleMenu();
	const { mutate: fetchJharokhaToken } = useMutateJharokhaToken();

	const handlePlayVideo = async (): Promise<void> => {
		try {
			setFullPageLoader(true);
			fetchJharokhaToken(undefined, {
				onSuccess: (jharokhaToken) => {
					if (jharokhaToken?.data?.token) {
						mutate(
							{
								productCode: product_code,
								token: jharokhaToken.data.token,
							},
							{
								onSuccess: (data) => {
									setFullPageLoader(false);
									if (data?.data?.video_url) {
										setVideoPlayerState(true, data?.data?.video_url);
										return;
									}
									setToaster(true, ToastType.error, NO_JHAROKHA_PRODUCT_VIDEO_FOUND);
								},
								onError: () => {
									setFullPageLoader(false);
									setToaster(true, ToastType.error, FAILED_TO_PLAY_VIDEO);
								},
							}
						);
					}
				},
				onError: () => {
					setFullPageLoader(false);
					setToaster(true, ToastType.error, FAILED_TO_PLAY_VIDEO);
				},
			});
		} catch (error) {
			setFullPageLoader(false);
			setToaster(true, ToastType.error, FAILED_TO_PLAY_VIDEO);
		}
	};

	return (
		<button className="video-btn" type="button" onClick={handlePlayVideo} aria-label="Play product video">
			<span className="icon-play"></span>
		</button>
	);
};
